import './i18n'

import Hotjar from '@hotjar/browser'
import { Suspense } from 'react'
import { hydrate, render } from 'react-dom'
import TagManager from 'react-gtm-module'

import App from './App'
import { Loading } from './components/common'
import ErrorBoundary from './hoc/ErrorBoundary'
import initBraze from './utils/initBraze'

// Caramelo GTM
TagManager.initialize({
  gtmId: 'GTM-KZLVHNL',
})

Hotjar.init(3539185, 6)

initBraze()

const Root = () => (
  <ErrorBoundary>
    <Suspense fallback={<Loading />}>
      <App />
    </Suspense>
  </ErrorBoundary>
)

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const rootElement = document.getElementById('root')!
if (!rootElement.innerHTML) {
  if (rootElement?.hasChildNodes()) {
    hydrate(<Root />, rootElement)
  } else {
    render(<Root />, rootElement)
  }
}
